<mat-toolbar role="heading" color="primary" class="header">
  <div class="seccion">
    <button mat-icon-button (click)="clickBotonSidenav.emit()">
      <mat-icon>menu</mat-icon>
    </button>
    <a class="logo" routerLink="/">
      <img src="assets/logo/atlas-light.png" />
      @if (logoOrg) {
        <img class="organizacion" [src]="logoOrg" />
      }
    </a>
  </div>
  <div class="seccion">
    <!-- Notificaciones -->
    @if (notificacionesService.notificaciones$ | async; as notificaciones) {
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon
          [matBadge]="notificacionesService.noLeidas$ | async"
          [matBadgeHidden]="(notificacionesService.noLeidas$ | async) == 0"
          matBadgeColor="warn"
          aria-hidden="false"
        >
          notifications
        </mat-icon>
      </button>
      <mat-menu #menu="matMenu" class="notificaciones">
        <h3 class="titulo"><mat-icon inline>notifications</mat-icon> Notificaciones</h3>
        <mat-divider></mat-divider>
        @if (notificaciones.length === 0) {
          <button mat-menu-item>
            <span>No hay notificaciones</span>
          </button>
        }
        <div class="notificaciones-cont">
          @for (notificacion of notificaciones; track notificacion; let i = $index) {
            <button mat-menu-item (click)="clickNotificacion(notificacion)">
              <div class="notificacion">
                @if (!notificacion.leida) {
                  <mat-icon class="color-warn"> circle </mat-icon>
                }
                @if (notificacion.leida) {
                  <mat-icon class="check"> check </mat-icon>
                }
                <div class="texto">
                  <p>{{ notificacion.mensaje }}</p>
                  <p class="fecha mat-small">
                    {{ notificacion.fechaCreacion | date: FORMATO_MOMENTO_PIPE_2 | titlecase }}
                  </p>
                </div>
              </div>
            </button>
            @if (i + 1 != notificaciones.length) {
              <mat-divider></mat-divider>
            }
          }
          <button
            mat-menu-item
            (click)="$event.stopPropagation(); notificacionesService.cargarMasNotificaciones$()"
            class="cargar-mas"
          >
            Cargar más...
          </button>
        </div>
      </mat-menu>
    }

    <!-- Perfil -->
    @if (usuario) {
      <button mat-icon-button [matMenuTriggerFor]="perfil">
        <mat-icon>person</mat-icon>
      </button>
      <mat-menu #perfil="matMenu" class="perfil">
        <h3 class="titulo"><mat-icon inline>person</mat-icon> Usuario</h3>
        <mat-divider></mat-divider>
        <p><b>Username:</b> {{ usuario.username }}</p>
        <p><b>Correo:</b> {{ usuario.email ?? 'Sin correo' }}</p>
        <p><b>Rol:</b> {{ usuario.rol | titlecase }}</p>
      </mat-menu>
    }

    <!-- Logout -->
    <button mat-icon-button (click)="autenticacionService.logout$()">
      <mat-icon>logout</mat-icon>
    </button>
  </div>
</mat-toolbar>
